import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const id = api.interceptors.response.use(undefined, (err) => {
      const s = err?.response?.status;
      const path = err?.config?.url || "";
      if ((s === 401 || (s === 403 && /disabled/i.test(err.response.data?.detail || ""))) && !path.startsWith("/auth/")) setUser(false);
      return Promise.reject(err);
    });
    return () => api.interceptors.response.eject(id);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  };

  const register = async (form) => {
    const { data } = await api.post("/auth/register", form);
    setUser(data);
  };

  const refreshUser = () => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {});

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, register, logout, refreshUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
